// This file allows us to lazily load the StandaloneVideo component.
// Due to our configuration this needs to be in js so we can use dynamic imports.
export {default as StandaloneVideo} from './StandaloneVideo';
